module.exports = __webpack_public_path__ + "img/jiaoxuemoshi_hover.572e0765.png";